// modules
import React, { FC } from 'react';
import { observer } from 'mobx-react';
// ui-library
import { Table, TableBody, TableHead, TableRow } from '@upstox/upstox-ui';
// modules
import OptionChain from 'modules/OptionChain';
// utils
import { getUniqueKey } from '../utils';
// components
import StrikesTableHeader from './StrikesTableHeader/StrikesTableHeader';
import StrikeTableRow from './StrikeTableRow';
// styles
import * as css from './styles';

const StrikesTable: FC = () => {
  const tableData = OptionChain.getOptionChainData('CE');

  return (
    <Table>
      <TableHead css={css.strikesTableHeader}>
        <StrikesTableHeader />
      </TableHead>
      <TableBody>
        {tableData.map((item) => {
          const uniqueKey = getUniqueKey(item);
          return (
            <TableRow
              css={css.rowProperties}
              key={uniqueKey}
              id={item.rowType === 'atm' ? 'spot-row' : uniqueKey.toString()}
            >
              <StrikeTableRow
                price={item.strike}
                rowType={item.rowType}
              />
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default observer(StrikesTable);
